import ApiService from "../ApiService";

const cancelReasonsService = {
    create(reason) {
        return ApiService.post(`/cancel-reason`, reason);
    },

    getPendings() {
        return ApiService.get(`/cancel-reason`);
    },
    updatePendingReason(id, data) {
        return ApiService.post(`/cancel-reason/update?id=${id}`, data);
    },
    deletePendingReason(data) {
        return ApiService.post(`/cancel-reason/remove`, data);
    }
};

export default cancelReasonsService;
